// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_cy-0";